<ion-app [class.dark-theme]="dark">
  <router-outlet></router-outlet>
</ion-app>